import React, { Fragment } from 'react';
import SkeletonLoadingComponent from '../SkeletonLoading';
import ImgRankingBg from '../../../assets/images/img_ranking_bakground.png';
import { ReactComponent as ImgAwards} from '../../../assets/images/img_awards.svg';

const LoadingAward = ({}) => {
  return (
    <Fragment>
      <div className="box-awards" style={{backgroundImage: `url("${ImgRankingBg}")`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundColor: '#fff'}}>
        <div className="box-awards__header">
          <div className="icon-awards">
            <span className=''>
              <ImgAwards />
            </span>
          </div>
        </div>
        <div className="box-awards__content">
          <div className="awards-top-hight pb-1">
            <div className="awards-top-third">
              <div className="item__top_second item__top_content  ">
                <div className="awards-top-third__item">
                  <div className="item-top-third-image text-center">
                    <SkeletonLoadingComponent width={85} height={128} />
                  </div>
                  <div className="info-top-rank">
                    <label className="info-top-rank__name text-truncate">
                      <SkeletonLoadingComponent width={70} />
                    </label>
                    <span className="info-top-rank__point">
                      <SkeletonLoadingComponent width={20} height={12} />
                    </span>
                  </div>
                </div>
              </div>
              <div className="item__top_first item__top_content  ">
                <div className="awards-top-third__item">
                  <div className="item-top-third-image text-center">
                    <SkeletonLoadingComponent width={85} height={128} />
                  </div>
                  <div className="info-top-rank">
                    <label className="info-top-rank__name text-truncate">
                      <SkeletonLoadingComponent width={70} />
                    </label>
                    <span className="info-top-rank__point">
                      <SkeletonLoadingComponent width={20} height={12} />
                    </span>
                  </div>
                </div>
              </div>
              <div className="item__top_second item__top_content  ">
                <div className="awards-top-third__item">
                  <div className="item-top-third-image text-center">
                    <SkeletonLoadingComponent width={85} height={128} />
                  </div>
                  <div className="info-top-rank">
                    <label className="info-top-rank__name text-truncate">
                      <SkeletonLoadingComponent width={70} />
                    </label>
                    <span className="info-top-rank__point">
                      <SkeletonLoadingComponent width={20} height={12} />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white"></div>
    </Fragment>
  );
};

export default LoadingAward;
